import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Menu from "./Menu";
import SeoMenu from "./SeoMenu";

const SeoLayout = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <SeoMenu />

                <Outlet />
                <div id="sidebar-overlay"></div>
            </div>
        </>
    );
};

export default SeoLayout;
